import { createRoutine, bindRoutineToReduxForm } from 'redux-saga-routines';

export const loginRoutine = createRoutine('LOGIN');
export const logoutRoutine = createRoutine('LOGOUT');
export const fetchUserRoutine = createRoutine('FETCH_USER');
export const selectTenantRoutine = createRoutine('SELECT_TENANT');
export const fetchTenantsRoutine = createRoutine('FETCH_TENANTS');

export const fetchStaticRoutine = createRoutine('FETCH_STATIC');

export const resetPasswordRoutine = createRoutine('RESET_PASSWORD');

export const registerRoutine = createRoutine('REGISTER');
export const registerFormHandler = bindRoutineToReduxForm(registerRoutine);

export const addTenantRoutine = createRoutine('ADD_TENANT');
export const addTenantFormHandler = bindRoutineToReduxForm(addTenantRoutine);

export const saveCustomerRoutine = createRoutine('SAVE_CUSTOMER');
export const removeCustomerRoutine = createRoutine('REMOVE_CUSTOMER');

export const saveJobRoutine = createRoutine('SAVE_JOB');
export const saveJobFormHandler = bindRoutineToReduxForm(saveJobRoutine);

export const saveJobResourcesRoutine = createRoutine('SAVE_JOB_RESOURCES');
export const removeJobRoutine = createRoutine('REMOVE_JOB');
export const fetchExceptionsRoutine = createRoutine('FETCH_EXCEPTIONS');

export const fetchTasksRoutine = createRoutine('FETCH_TASKS');
export const removeTasksRoutine = createRoutine('REMOVE_TASKS');
export const saveTaskAssignmentsRoutine = createRoutine('SAVE_TASK_ASSIGNMENTS');

export const saveEmployeeRoutine = createRoutine('SAVE_EMPLOYEE');
export const removeEmployeeRoutine = createRoutine('REMOVE_EMPLOYEE');

export const fetchLabelFormatsRoutine = createRoutine('FETCH_LABEL_FORMATS');
export const editTaskRoutine = createRoutine('EDIT_TASK');


export const fetchRolesRoutine = createRoutine('FETCH_ROLES');
export const saveRoleRoutine = createRoutine('SAVE_ROLE');
export const removeRoleRoutine = createRoutine('REMOVE_ROLE');

export const saveJobProfileRoutine = createRoutine('SAVE_JOB_PROFILE');
export const saveJobProfileFormHandler = bindRoutineToReduxForm(saveJobProfileRoutine);
export const removeJobProfileRoutine = createRoutine('REMOVE_JOB_PROFILE');

export const saveTaskProfileRoutine = createRoutine('SAVE_TASK_PROFILE');
export const saveTaskProfileFormHandler = bindRoutineToReduxForm(saveTaskProfileRoutine);
export const removeTaskProfileRoutine = createRoutine('REMOVE_TASK_PROFILE');

export const fetchSettingsRoutine = createRoutine('FETCH_SETTINGS');
export const upgradeTenantRoutine = createRoutine('UPGRADE_TENANT');
export const getTaskCountRoutine = createRoutine('GET_TASK_COUNT');
export const getPaymentSourceRoutine = createRoutine('GET_PAYMENT_SOURCE');
export const updatePaymentSourceRoutine = createRoutine('UPDATE_PAYMENT_SOURCE');
export const fetchInvoicesRoutine = createRoutine('FETCH_INVOICES');

export const cancelAccountRoutine = createRoutine('CANCEL_ACCOUNT');

export const fetchPrintersRoutine = createRoutine('FETCH_PRINTERS');
export const removePrinterRoutine = createRoutine('REMOVE_PRINTER');
export const savePrinterRoutine = createRoutine('SAVE_PRINTER');
export const savePrinterFormHandler = bindRoutineToReduxForm(savePrinterRoutine);



// WEBPACK FOOTER //
// ./src/routines.js